// src/utils/contentEvents.js
//
// CONTENT-USE EVENTS. One small document per "a member opened something":
// a topic page, a video or template, a worksheet, a talk guide, a pledge link,
// the Talk to Someone outlet. Count-only by design: NO user id, NO name, NO
// score, nothing a member answered. What is kept is enough to say "how many
// times did U15 players on this org open the Resilience videos in November",
// aggregated server-side under the usual k >= 5 floor (pilot plan B11; the
// same mechanism the EAP referral count needs).
//
// Written straight from the client to `content_events` (rules: signed-in
// members may create one with exactly these fields; nobody reads them from a
// client). Preview mode records nothing. A failure is swallowed: analytics
// must never break a page.

import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase-config';
import { resolveAgeTier } from './ageTier';

export const CONTENT_EVENTS = ['topic_view', 'resource_open', 'worksheet_open', 'guide_open', 'pledge_link', 'support_open'];

const day = () => new Date().toISOString().slice(0, 10);

export const recordContentEvent = (event, { user, org, isPreviewMode = false, topicId = null, resourceId = null, resourceType = null, surface = null } = {}) => {
    try {
        if (isPreviewMode || !CONTENT_EVENTS.includes(event)) return;
        const orgId = org?.id || user?.organizationId || null;
        if (!orgId) return;
        const payload = {
            orgId,
            groupId: user?.groupId || null,
            memberType: user?.memberType || null,
            ageTier: resolveAgeTier(user) || 'unknown',
            surface: surface || null,
            event,
            topicId: topicId || null,
            resourceId: resourceId != null ? String(resourceId) : null,
            resourceType: resourceType || null,
            day: day(),
            ts: serverTimestamp()
        };
        addDoc(collection(db, 'content_events'), payload).catch(() => { /* never block a page on analytics */ });
    } catch (e) { /* ignore */ }
};
